import React from 'react'
import DOM from 'react-dom'
import { findNode } from '@ra/lib-common/dom'

/**
 * Renders the entry component for a module.
 *
 * @param {Node | string} nodeOrSelector Either the DOM node or selector for
 *   finding the node to render into.
 * @param {object} options Module component options from edit dialog.
 * @param {object} config Configuration details.
 */
export function renderModule(nodeOrSelector, { width }, config) {
  const { className, Entry = React.Fragment } = config

  const rootNode = getRootNode(nodeOrSelector, className, width)

  DOM.render(<Entry {...config} />, rootNode)
}

/**
 * Renders the entry component for a module that uses Microcosm.
 *
 * @param {Node | string} nodeOrSelector Either the DOM node or selector for
 *   finding the node to render into.
 * @param {object} options Module component options from edit dialog.
 * @param {object} config Configuration details.
 */
export function renderMicrocosmModule(nodeOrSelector, options, config) {
  const {
    className,
    repoClass,
    bootAction,
    getBootProps = (options) => ({ options }),
    Entry = React.Fragment,
  } = config

  const rootNode = getRootNode(nodeOrSelector, className)

  const repo = new repoClass({
    debug: process.env.NODE_ENV === 'development',
    batch: true,
  })

  repo.push(bootAction, getBootProps(options))

  DOM.render(<Entry {...config} repo={repo} />, rootNode)
}

/**
 * Gets a reference to the root node.
 *
 * @param {Node | string} nodeOrSelector Either the DOM node or selector for
 *   finding the node to render into.
 * @param {string} className Class name to apply to the root node.
 * @returns Root node.
 */
export function getRootNode(nodeOrSelector, className, style) {
  const rootNode = findNode(nodeOrSelector)

  console.assert(
    rootNode instanceof HTMLElement,
    `No root node found. Did you pass an HTML Element or selector?`
  )

  if (className) {
    rootNode.classList.add(className)
  }

  if (style) {
    rootNode.style = rootNode.style.cssText + style
  }

  return rootNode
}
